/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormDesignerExtras } from '../models/FormDesignerExtras';
import type { StringStringKeyValuePair } from '../models/StringStringKeyValuePair';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormDesignerExtrasService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param orgGuid
     * @returns FormDesignerExtras OK
     * @throws ApiError
     */
    public getFormDesignerExtras(
        orgGuid: string,
    ): CancelablePromise<FormDesignerExtras> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/FormDesignerExtras/{orgGuid}/GetFormDesignerExtras',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param orgGuid
     * @returns StringStringKeyValuePair OK
     * @throws ApiError
     */
    public getApiMwformsFormDesignerExtrasGetAvailableTables(
        orgGuid: string,
    ): CancelablePromise<Array<StringStringKeyValuePair>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/FormDesignerExtras/{orgGuid}/GetAvailableTables',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param tableName
     * @param orgGuid
     * @returns StringStringKeyValuePair OK
     * @throws ApiError
     */
    public getApiMwformsFormDesignerExtrasGetTableColumns(
        tableName: string,
        orgGuid: string,
    ): CancelablePromise<Array<StringStringKeyValuePair>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/FormDesignerExtras/{orgGuid}/GetTableColumns/{tableName}',
            path: {
                'tableName': tableName,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
